// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

declare const APP_VERSION: string;

export const environment = {
  apiUrl: window.env.API_URL,
  isDev: Boolean(window.env.DEV ?? false),
  supportEmail: window.env.SUPPORT_EMAIL,
  temporaryUserPermissionMaxDaysDuration:
    window.env.TEMPORARY_USER_PERMISSION_MAX_DAYS_DURATION,
  clarityProjectId: window.env.CLARITY_PROJECT_ID,
  internalUserEmailDomains: window.env.INTERNAL_USER_EMAIL_DOMAINS,
  partnerUserEmailDomains: window.env.PARTNER_USER_EMAIL_DOMAINS,
  termsOfUseUrl: window.env.ZSPACE_TERMS_OF_USE_URL,
  privacyPolicyUrl: window.env.ZSPACE_PRIVACY_POLICY_URL,
  legalUrl: window.env.ZSPACE_LEGAL_URL,
  supportUrl: window.env.ZSPACE_SUPPORT_URL,
  appVersion: APP_VERSION,
  managementHubLicenseStartDate: window.env.MANAGEMENT_HUB_LICENSE_START_DATE,
};
